const DEFAULT_ALLOWED_PROTOCOLS = [
  'https:',
  ...(process.env.NODE_ENV === 'development' ? ['http:'] : [])
];

export function sanitizeUrl(
  value: string,
  allowedProtocols: string[] = DEFAULT_ALLOWED_PROTOCOLS
): string {
  if (!value) return '';

  try {
    const parsedUrl = new URL(value, window.location.origin);
    return allowedProtocols.includes(parsedUrl.protocol) ? parsedUrl.toString() : '';
  } catch (error) {
    return '';
  }
}
